import { useEffect } from "react";

import { useHasConsent } from "@/hooks/use-consent";
import { ConsentGroup } from "@/lib/consent";
import { captureUtm } from "@/lib/utm";

/**
 * First-touch UTM capture for public pages. Runs on mount (returning visitors
 * who already consented) and again if Targeting consent is granted during this
 * page view. A no-op unless consent is granted and `utm_*` params are present.
 */
export function useUtmCapture(): void {
  const targetingGranted = useHasConsent(ConsentGroup.Targeting);
  useEffect(() => {
    if (targetingGranted) captureUtm();
  }, [targetingGranted]);
}
